import React from "react";
import LegalPage from "@/pages/LegalPage";

const Terms = () => (
  <LegalPage
    title="Terms of Use"
    lastUpdated="December 2025"
    sections={[
      {
        heading: "Acceptance",
        body: [
          "By accessing or using matimitra.earth (the \"site\") you agree to these Terms of Use. If you do not agree, please do not use the site.",
        ],
      },
      {
        heading: "Content & accuracy",
        body: [
          "The information on this site is provided for general informational purposes about the MatiMitra Carbon Solutions Pvt. Ltd. biochar carbon-removal project. We work to keep it accurate and current but make no warranties, express or implied, regarding completeness, reliability or fitness for a particular purpose. Project metrics, timelines and methodology references may evolve as the project progresses.",
        ],
      },
      {
        heading: "No offer of securities or credits",
        body: [
          "Nothing on this site constitutes an offer to sell, or a solicitation of an offer to buy, any carbon credits, securities, or financial instruments. Any commercial engagement will be governed by separate written agreements.",
        ],
      },
      {
        heading: "Intellectual property",
        body: [
          "All site content — including text, photographs, logos and marks — is owned by MatiMitra Carbon Solutions Pvt. Ltd. or our licensors and is protected by applicable copyright and trademark law. You may not reproduce, distribute, or create derivative works without our prior written consent.",
        ],
      },
      {
        heading: "Third-party links",
        body: [
          "The site may link to external resources (for example, the Rainbow Registry project listing). We are not responsible for the content or practices of any third-party site.",
        ],
      },
      {
        heading: "Limitation of liability",
        body: [
          "To the maximum extent permitted by law, MatiMitra Carbon Solutions Pvt. Ltd. and its directors, employees and affiliates will not be liable for any indirect, incidental, consequential or punitive damages arising out of your access to or use of the site.",
        ],
      },
      {
        heading: "Governing law",
        body: [
          "These Terms are governed by the laws of India. Any disputes arising in connection with the site or these Terms will be subject to the exclusive jurisdiction of the courts of Odisha, India.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "Questions about these Terms can be sent to support@matimitra.earth.",
        ],
      },
    ]}
  />
);

export default Terms;
